import PodcastFeedClient from '@wix/podcasts-feed-client';

const feedClient: PodcastFeedClient = new PodcastFeedClient();

export { feedClient };
